import { ChartTooltipStyled } from 'components/Charting/Tooltip/ChartTooltip.styled';
import { forwardRef, ReactNode } from 'react';
import { createPortal } from 'react-dom';

type ChartTooltipProps = {
  children: ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

const ChartTooltip = forwardRef<HTMLDivElement, ChartTooltipProps>(
  ({ children, ...props }, ref) => {
    return createPortal(
      <ChartTooltipStyled ref={ref} {...props}>
        {children}
      </ChartTooltipStyled>,
      document.body,
    );
  },
);

export default ChartTooltip;
